export default "__VITE_ASSET__CfVjefXR__"